// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a4cda204","479":"a0e7311a"}[chunkId] + ".chunk.js";
};